import React, {Component} from 'react';

class CallAction extends Component {
	render() {
		const {callActionButton, link} = this.props;

		return (
			<section id="sgStart" className="gcAd-section game-start" data-section="6">
				<a href={link}>
					<div className="gcAd-game-start">
						{callActionButton}
					</div>
				</a>
			</section>
		)
	}
}

export default CallAction;


// WEBPACK FOOTER //
// ./src/Components/Advert-CallAction.js